import React, { Component } from 'react';
import { APP_CONST } from '../../../../constants';
import { GeckoFields, Spinner } from '../../../../components';
import ActivityTable from './components/ActivityTable';
import Queries from './Queries';
import './styles.css';


export class ModuleActivity extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            perPage: 10,
            nextPage: null,
            loading: false,
        }

        this.getActivity = this.getActivity.bind(this);
        this.loadMore = this.loadMore.bind(this);
    }

    componentDidMount() {
        this.loadMore();
    }

    getActivity(perPage = 10, nextPage = null) {
        this.setState({
            loading: true,
        });

        Queries.getActivity(perPage, nextPage)
        .then((response) => {
            this.setState({
                data: this.state.data.concat(response.events),
                nextPage: response.nextPage || null,
                loading: false,
            })
        }).catch((err) => {
            this.props.setAlert(err.message);
            
            this.setState({
                loading: false,
            });
        })
    }

    loadMore() {
        return this.getActivity(this.state.perPage, this.state.nextPage);
    }

    renderSpinner(loading = false) {
        if (!loading) return null;

        return (
            <div className="d-flex flex-row justify-content-center align-items-center">
                <Spinner />
            </div>
        )
    }

    renderLoadMoreButton(nextPage = false, loading = false) {
        if (!nextPage || loading) return null;

        return (
            <a className="loadMore text-center" onClick={this.loadMore}>Load More</a>
        )
    }

    renderTable(data) {
        return <ActivityTable data={data} />
    }

    render() {
        return (
            <div>
                {this.renderTable(this.state.data)}
                {this.renderSpinner(this.state.loading)}
                {this.renderLoadMoreButton(this.state.nextPage, this.state.loading)}
            </div>
        )
    }
}

ModuleActivity.defaultProps = {
    setAlert: () => null,
}

export default ModuleActivity;